/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input} from '@angular/core';

@Component({
  selector: 'well-subscriptions-tab',
  templateUrl: './subscriptions-tab.component.html',
  styleUrls: ['./subscriptions-tab.component.scss']
})
export class SubscriptionsTabComponent {

  @Input() subscriptionTypeUuid: string | undefined = undefined;

  newSubscription = false;

  addNew() {
    this.showNewInputs()
  }

  private showNewInputs() {
    this.newSubscription = true;
  }

  hideNewInputs() {
    this.newSubscription = false;
  }
}
